import * as React from "react";
import './button-spinner.scss';

export const ButtonSpinner = ({size = 16, numOfSpokes = 8, spinnerColor = "#445870"}) => {

  const styles = (idx = null) => ({
    spokedButtonSpinner: {
      width: size,
      height: size,
      position: "relative",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      "--my-var": numOfSpokes,
      "--var-color": spinnerColor,
    },
    buttonSpinnerSpoke: {
      width: "100%",
      height: "9%",
      position: "absolute",
      transform: 'rotate('+ (360/numOfSpokes) * idx +'deg)'
    },
    spokeBase: {
      width: "72%",
      height: "100%",
      position: "absolute",
      opacity: 0,
    },
    spokeEnd: {
      width: "28%",
      height: "100%",
      position: "absolute",
      borderRadius: 3,
      backgroundColor: spinnerColor,
      opacity: 1/numOfSpokes * (idx + 1),
    }
  });

  return(
    <div
      className="spokedButtonSpinner"
      style={styles().spokedButtonSpinner}
    >
      {[...Array(numOfSpokes)].map((_, idx) =>
        <div className="buttonSpinnerSpoke"
          id={"spokeMain-"+idx}
          style={styles(idx).buttonSpinnerSpoke}
          key={"spinner-spoke-div-"+idx}
        >
          <div className="buttonSpinnerSpokeBase"
            id={"spoke-"+idx+"-TransparentBase"}
            style={styles().spokeBase}
          />
          <div className="buttonSpinnerSpokeEnd"
            id={"spoke-"+idx+"-Shown"}
            style={styles(idx).spokeEnd}
          />
        </div>
      )}
    </div>
  );
}